import Logo from '@/assets/images/family-mode-logo.png';
import EmptyTape from '@/assets/images/bg-img-1.png';
import EmptySilhouette from '@/assets/images/bg-img-2.png';
import LabelName from '@/assets/images/label-name.png';
import PopupBg from '@/assets/images/popup-bg.png';
import Avatar from '@/assets/images/avatar.png';

export const Images = {
  Logo,
  EmptyTape,
  EmptySilhouette,
  LabelName,
  PopupBg,
  Avatar
};